import getFilters from './getFilters';
import saveFilters from './saveFilters';
import parseToJsonAndUpdateDefaultFilters from './parseToJsonAndUpdateDefaultFilters';
import sendNotifications from '../notifications/send';
import clearOverrideFilters from '../media/clearOverrideFilters';

import combineActions from '../../utils/combineActions';

export default combineActions({
    getFilters,
    saveFilters,
    parseToJsonAndUpdateDefaultFilters,
    sendNotifications,
    clearOverrideFilters,
});
